import { atom } from 'recoil';
import { ICombatBuffs } from '../../../game-server/src/modules/combat/Combat.interface';

export const combatBuffsAtom = atom({
	key: 'combatBuffsAtom',
	default: [] as ICombatBuffs[],
});
